import React from "react";
import {
  Button,
  FormFieldSet,
  showToast,
  useFormHandler,
} from "../../../../../../../components";

const EditDeduction = ({ onClose }) => {
  const initialFormData = {
    deductionName: "",
    deductionType: "",
    payDate: "",
    attachment: "",
    deductionAmount: "",
    paymentType: "",
    startCycle: "",
    taxDeduction: "pre",
    modeOfDeduction: "parallel",
    comment: "",
  };

  const { formData, setFormData, handleChange, validateAllFields } =
    useFormHandler(initialFormData, {
      deductionName: { type: "text", required: true },
    });
  const handleSave = () => {
    const isValid = validateAllFields();
    if (!isValid) {
      showToast("Required fields are missing!", "error");
      return;
    }
    onClose();
    setFormData(initialFormData);
    showToast("Pending for Approval", "success");
  };
  return (
    <div className="rounded-lg w-full">
      <div className="px-5 py-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <FormFieldSet
          title="Deduction Name"
          type="text"
          placeholder="Deduction Name"
          value={formData?.deductionName}
          onChange={(val) => handleChange("deductionName", val)}
          required
        />

        <FormFieldSet
          title="Deduction Type"
          type="text"
          placeholder="Deduction Type"
          value={formData?.deductionType}
          onChange={(val) => handleChange("deductionType", val)}
        />

        <FormFieldSet
          title="Pay Date"
          type="datepicker"
          value={formData?.payDate}
          onChange={(val) => handleChange("payDate", val)}
          placeholder="select Date"
          showDropdown={false}
        />

        <FormFieldSet
          title="Attachment"
          type="file"
          value={formData?.attachment}
          onChange={(val) => handleChange("attachment", val)}
        />

        <FormFieldSet
          title="Deduction Amount"
          type="text"
          placeholder="Deduction Amount"
          value={formData?.deductionAmount}
          onChange={(val) => handleChange("deductionAmount", val)}
        />

        <FormFieldSet
          title="Payment Type"
          type="text"
          placeholder="Payment Type"
          value={formData?.paymentType}
          onChange={(val) => handleChange("paymentType", val)}
        />

        <FormFieldSet
          title="Start Cycle"
          type="datepicker"
          value={formData?.startCycle}
          onChange={(val) => handleChange("startCycle", val)}
          placeholder="select Date"
          showDropdown={false}
        />

        {/* Tax Deduction */}
        <div className="col-span-1">
          <FormFieldSet
            type="radio"
            title="Tax Deduction"
            name="Select"
            options={[
              { label: "Pre - Tax Deduction", value: "pre" },
              { label: "Post - Tax Deduction", value: "post" },
            ]}
            value={formData?.taxDeduction}
            onChange={(e) => handleChange("taxDeduction", e.target.value)}
          />
        </div>

        {/* Mode of Deduction */}
        <div className="col-span-1 flex! gap-2">
          <FormFieldSet
            type="radio"
            title="Mode of Deduction"
            name="Select mode"
            options={[
              { label: "Parallel Deduction", value: "parallel" },
              { label: "One after another", value: "sequence" },
            ]}
            value={formData?.modeOfDeduction}
            onChange={(e) => handleChange("modeOfDeduction", e.target.value)}
          />
        </div>
      </div>

      {/* Comment */}
      <div className="px-5 pb-4">
        <FormFieldSet
          type="textArea"
          title="Add comment"
          placeholder="Enter comment"
          rows={4}
          value={formData?.comment}
          onChange={(val) => handleChange("comment", val)}
        />
      </div>

      <div className="flex justify-end px-5 pb-4">
        <Button title="Save" color="primary" onClick={handleSave} />
      </div>
    </div>
  );
};

export default EditDeduction;
